import * as React from 'react';
import { Link } from 'react-router-dom';

/**
 * NotFoundPage Route Component
 *
 * Displayed when a user navigates to a non-existent route.
 * Provides a clear message and a redirection link to the homepage.
 */
export const NotFoundPage: React.FC = () => (
  <div className='flex min-h-screen flex-col items-center justify-center bg-brand-25 p-4 text-center'>
    <h1 className='mb-4 text-6xl font-bold text-brand-800'>404</h1>

    <h2 className='mb-2 text-2xl font-semibold text-dark-100'>Page Not Found</h2>

    <p className='mb-6 text-gray-500'>Sorry, the page you are looking for does not exist.</p>

    <Link
      to='/'
      className='inline-flex h-9 items-center justify-center rounded-md bg-brand-800 px-4 py-2 text-sm font-medium text-white shadow transition-colors hover:bg-brand-900'
    >
      Go to Homepage
    </Link>
  </div>
);
